import * as React from "react";
export var FilterIcon = function () {
    return (React.createElement("svg", { version: "1.1", x: "0px", y: "0px", viewBox: "0 0 100 125", enableBackground: "new 0 0 100 100", xmlSpace: "preserve" },
        React.createElement("g", { display: "none" },
            React.createElement("circle", { display: "inline", fill: "#000000", cx: "50", cy: "50", r: "40" }),
            React.createElement("circle", { display: "inline", fill: "#000000", cx: "50", cy: "50", r: "40" })),
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("path", { d: "M29.5,40.7c4.4,0,8.1-3,9.2-7h40.7v-5H38.7c-1.1-4-4.8-7-9.2-7c-5.2,0-9.5,4.3-9.5,9.5C20,36.5,24.3,40.7,29.5,40.7z" }),
                React.createElement("path", { d: "M70.8,56.5c-4.4,0-8.1,3-9.2,7h-41v5h41c1.1,4,4.8,7,9.2,7c5.2,0,9.5-4.3,9.5-9.5S76,56.5,70.8,56.5z" })))));
};
//# sourceMappingURL=FilterIcon.js.map